module.exports = __webpack_public_path__ + "img/Menu icon.b5c26693.svg";